export class managementPriceFormController {
    ajaxLoading: boolean;
    productOptionLoaded: any;
    warrantyOptionsLoaded: any;
    salableItemLoaded: any;
    loading: boolean = true;;
    salableOptions: any;
    warrantyOptions: any;
    salableItem
    datepickerConfig = {
        allowFuture: true,
        dateFormat: 'jYYYY/jMM/jDD',
        gregorianDateFormat: 'YYYY/DD/MM',
    }
    constructor(private $SalableItems, private $mdDialog) {
        "ngInject"

    }

    $onInit() {
        this.$SalableItems.getWarranty(
            {
                TypeID: 4,
                ID: this.salableItem.productId
            },
            response => {
                this.warrantyOptions = response
                this.warrantyOptionsLoaded = true;
                this.fullyLoad()
            }
        )

        this.$SalableItems.getOptions(
            {
                ProductID: this.salableItem.productId
            },
            response => {
                this.salableOptions = response;
                this.productOptionLoaded = true;
                this.fullyLoad()
            }
        )
        if (this.salableItem.SalableItemID) {

            this.$SalableItems.getOne(
                {
                    salableItemId: this.salableItem.SalableItemID
                },
                response => {
                    if (response.Quantity == -1) { response.countType = 'unlimited' }
                    else if (response.Quantity == 0) { response.countType = 'noExist' }
                    else { response.countType = 'count' }
                    if (response.MinimumOrderCount > 1) {
                        response.wholeSale = true
                    }
                    this.salableItem = response
                    this.salableItemLoaded = true;
                    this.fullyLoad()
                }
            )
        }
        else {
            this.salableItemLoaded = true;
            this.fullyLoad()
        }
    }

    fullyLoad() {
        if (this.salableItemLoaded && this.warrantyOptionsLoaded && this.productOptionLoaded) {
            this.loading = false
        }
    }

    save() {
        this.ajaxLoading = true
        if (this.salableItem.countType == 'unlimited') { this.salableItem.Quantity = -1 }
        else if (this.salableItem.countType == 'noExist') { this.salableItem.Quantity = 0 }
        if (!this.salableItem.wholeSale) {
            this.salableItem.MinimumOrderCount = 1
        }
        this.$SalableItems.saveOne(this.salableItem,
            response => {
                this.$mdDialog.hide(response)
            },
            reject => {
                this.loading = false;

            }
        )
    }

    cancel() {
        this.$mdDialog.cancel()
    }

    countInputInit() {
        if (this.salableItem.Quantity < 1) {

            this.salableItem.Quantity = 1
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/management-price-form/management-price-form.controller.ts